(function () {
  'use strict';

  function initArticle(section) {
    if (section.dataset.ddArticleReady === 'true') return;

    var content = section.querySelector('[data-dd-article-content]');
    var rail = section.querySelector('[data-dd-article-toc]');
    var progress = section.querySelector('[data-dd-article-progress]');
    if (!content || !rail) return;

    section.dataset.ddArticleReady = 'true';

    var updateProgress = function () {
      if (!progress) return;

      var headerBottom = parseFloat(getComputedStyle(document.body).getPropertyValue('--dd-article-header-bottom')) || 0;
      var contentTop = content.getBoundingClientRect().top + window.scrollY;
      var contentHeight = content.offsetHeight;
      var readingViewport = Math.max(window.innerHeight - headerBottom, 1);
      var distance = Math.max(contentHeight - readingViewport, 1);
      var consumed = window.scrollY + headerBottom - contentTop;
      var value = Math.min(Math.max(consumed / distance, 0), 1);
      var active = consumed >= 0 && consumed <= distance + readingViewport;

      progress.style.setProperty('--dd-article-progress', value.toFixed(4));
      progress.classList.toggle('is-active', active);
    };

    section.ddUpdateProgress = updateProgress;

    var h2s = Array.prototype.slice.call(content.querySelectorAll('h2'));
    var tocHeading = h2s.find(function (heading) {
      var list = heading.nextElementSibling;
      return list && /^(UL|OL)$/.test(list.tagName) && list.querySelector('a[href^="#"]');
    });
    var tocList = tocHeading && tocHeading.nextElementSibling;

    var articleHeadings = h2s.filter(function (heading) {
      return heading !== tocHeading;
    });
    articleHeadings.forEach(function (heading, index) {
      heading.dataset.ddSection = String(index + 1).padStart(2, '0');
    });

    Array.prototype.slice.call(content.querySelectorAll('table')).forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('dd-article-table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'dd-article-table-scroll';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    if (!tocHeading || !tocList) return;

    var railTitle = document.createElement('p');
    railTitle.className = 'dd-article-light-toc__title';
    railTitle.textContent = tocHeading.textContent.trim();

    var nav = document.createElement('nav');
    nav.className = 'dd-article-light-toc__nav';
    nav.setAttribute('aria-label', tocHeading.textContent.trim());
    nav.appendChild(tocList.cloneNode(true));
    rail.appendChild(railTitle);
    rail.appendChild(nav);

    var details = document.createElement('details');
    details.className = 'dd-article-light-toc-mobile';
    var summary = document.createElement('summary');
    var summaryTitle = document.createElement('span');
    var summaryCount = document.createElement('span');
    summaryTitle.textContent = tocHeading.textContent.trim();
    summaryCount.textContent = tocList.querySelectorAll('a[href^="#"]').length;
    summary.appendChild(summaryTitle);
    summary.appendChild(summaryCount);
    details.appendChild(summary);
    details.appendChild(tocList.cloneNode(true));
    tocHeading.parentNode.insertBefore(details, tocHeading);
    tocHeading.hidden = true;
    tocList.hidden = true;

    var railLinks = Array.prototype.slice.call(rail.querySelectorAll('a[href^="#"]'));
    var targets = railLinks.map(function (link) {
      try {
        return content.querySelector(link.getAttribute('href'));
      } catch (error) {
        return null;
      }
    }).filter(Boolean);

    if ('IntersectionObserver' in window && targets.length) {
      var setActive = function (id) {
        railLinks.forEach(function (link) {
          var active = link.getAttribute('href') === '#' + id;
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      var observer = new IntersectionObserver(function (entries) {
        var visible = entries.filter(function (entry) { return entry.isIntersecting; });
        if (visible.length) {
          visible.sort(function (a, b) { return a.boundingClientRect.top - b.boundingClientRect.top; });
          setActive(visible[0].target.id);
        }
      }, { rootMargin: '-18% 0px -68% 0px', threshold: 0 });

      targets.forEach(function (target) { observer.observe(target); });
    }
  }

  function updateStickyOffset() {
    var header = document.querySelector('.header-section') || document.getElementById('HeaderWrapper') || document.querySelector('.site-header');
    var bottom = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 96;
    document.body.style.setProperty('--dd-article-header-bottom', Math.round(bottom) + 'px');
    document.body.style.setProperty('--dd-article-sticky-top', Math.round(bottom + 28) + 'px');

    document.querySelectorAll('[data-dd-article-light]').forEach(function (section) {
      if (section.ddUpdateProgress) section.ddUpdateProgress();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-dd-article-light]').forEach(initArticle);
    updateStickyOffset();
  }

  var updateFrame;
  function requestLayoutUpdate() {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(function () {
      updateFrame = null;
      updateStickyOffset();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  window.addEventListener('resize', requestLayoutUpdate, { passive: true });
  window.addEventListener('scroll', requestLayoutUpdate, { passive: true });
  document.addEventListener('headerStickyChange', requestLayoutUpdate);
  document.addEventListener('shopify:section:load', initAll);
})();
